import { render, staticRenderFns } from "./table-log-book.vue?vue&type=template&id=241b0ab9&scoped=true"
import script from "./table-log-book.vue?vue&type=script&lang=js"
export * from "./table-log-book.vue?vue&type=script&lang=js"
import style0 from "./table-log-book.vue?vue&type=style&index=0&id=241b0ab9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241b0ab9",
  null
  
)

export default component.exports